/**
 * Muted inline autoplay helper (SEO-safe: does not remove or defer video markup).
 * Retries play() after lazyload / buffer / visibility; pauses off-screen carousel slides.
 */
(function () {
  var SELECTOR =
    'video[data-autoplay-video], video[autoplay][muted][playsinline], video[autoplay][muted][webkit-playsinline]';

  function isManaged(video) {
    if (!video || video.tagName !== 'VIDEO') return false;
    if (video.hasAttribute('data-autoplay-video')) return true;
    return (
      video.hasAttribute('autoplay') &&
      video.hasAttribute('muted') &&
      (video.hasAttribute('playsinline') || video.hasAttribute('webkit-playsinline'))
    );
  }

  function ensureMutedInline(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function tryPlay(video) {
    if (!isManaged(video)) return;
    ensureMutedInline(video);
    if (!video.paused && !video.ended) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    video.pause();
  }

  function bindLoadEvents(video) {
    if (video._cagAutoplayBound) return;
    video._cagAutoplayBound = true;
    ensureMutedInline(video);

    var onReady = function () {
      if (video._cagInView !== false) tryPlay(video);
    };

    ['loadedmetadata', 'loadeddata', 'canplay'].forEach(function (name) {
      video.addEventListener(name, onReady);
    });
    video.addEventListener('lazyloaded', onReady);
    video.addEventListener('error', function () {
      video._cagAutoplayFailed = true;
    });
  }

  function observeVisibility(video) {
    if (video._cagAutoplayObserved) return;
    video._cagAutoplayObserved = true;
    bindLoadEvents(video);

    if (!('IntersectionObserver' in window)) {
      video._cagInView = true;
      tryPlay(video);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== video) return;
          video._cagInView = entry.isIntersecting;
          if (entry.isIntersecting) {
            tryPlay(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px 5% 0px' }
    );

    observer.observe(video);
    tryPlay(video);
  }

  function initVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(function (video) {
      if (!isManaged(video)) return;
      observeVisibility(video);
    });
  }

  function playVideosInSlide(slideEl) {
    if (!slideEl) return;
    slideEl.querySelectorAll(SELECTOR).forEach(function (video) {
      if (!isManaged(video)) return;
      video._cagInView = true;
      tryPlay(video);
    });
  }

  function pauseVideosOutsideSlide(sliderEl, activeSlide) {
    if (!sliderEl) return;
    sliderEl.querySelectorAll(SELECTOR).forEach(function (video) {
      if (activeSlide && activeSlide.contains(video)) return;
      video._cagInView = false;
      pauseVideo(video);
    });
  }

  function hookSlickSliders() {
    if (typeof jQuery === 'undefined') return;

    var $ = jQuery;
    var sliderSelector =
      '.instagramoff-slider, [data-section-type="slickCarousels"]';

    function onSlideChange(event, slick) {
      if (!slick || !slick.$slides) return;
      var $current = $(slick.$slides.get(slick.currentSlide));
      var $slider = $(slick.$slider);
      pauseVideosOutsideSlide($slider[0], $current[0]);
      playVideosInSlide($current[0]);
    }

    $(document).on('init afterChange', sliderSelector, onSlideChange);

    $(sliderSelector + '.slick-initialized').each(function () {
      var slick = $(this).slick('getSlick');
      if (slick) onSlideChange(null, slick);
    });
  }

  function unlockOnGesture() {
    var done = false;
    function once() {
      if (done) return;
      done = true;
      document.querySelectorAll(SELECTOR).forEach(function (video) {
        if (!isManaged(video)) return;
        if (video._cagInView !== false) tryPlay(video);
      });
    }
    document.addEventListener('touchstart', once, { once: true, passive: true });
    document.addEventListener('click', once, { once: true });
  }

  function boot() {
    initVideos(document);
    hookSlickSliders();
    unlockOnGesture();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVideos(event.target);
    setTimeout(hookSlickSliders, 400);
  });

  window.addEventListener('load', function () {
    initVideos(document);
    setTimeout(hookSlickSliders, 600);
  });

  window.addEventListener(
    'resize',
    function () {
      document.querySelectorAll(SELECTOR).forEach(function (video) {
        if (!isManaged(video) || video._cagInView === false) return;
        tryPlay(video);
      });
    },
    { passive: true }
  );
})();
